import NftMetadata from "../interfaces/NftMetadata"
import { BASE_POWER, BASE_RATE } from "../vars"

export default (nft: NftMetadata, lastClaim: number) => {
    const unixTimestamp = Math.round(Date.now() / 1000)
    const earnedPoints = (unixTimestamp - lastClaim) * BASE_RATE

    return earnedPoints
}